import type { ComponentPropsWithoutRef } from 'react'
import { cx } from '@/lib/cx'

export type ButtonVariant = 'primary' | 'secondary' | 'destructive' | 'tertiary' | 'gold'

type ButtonProps = ComponentPropsWithoutRef<'button'> & {
  variant?: ButtonVariant
}

export function Button({ variant = 'primary', className, type = 'button', ...props }: ButtonProps) {
  return (
    <button
      type={type}
      data-variant={variant}
      className={cx('btn', `btn--${variant}`, className)}
      {...props}
    />
  )
}
